import React, { useEffect, useState, Fragment } from 'react';
import Page from '../../containers/Page';
import ListSection from './ListSection';
import { Switch, Route, Link, useRouteMatch } from 'react-router-dom';
import ItemForm from '../Forms/ItemForm';
import FloatingActionBtn from '../Buttons/FloatingActionBtn';
import SearchBar from '../Forms/SearchBar';
import NoResult from '../Forms/NoResult';

function ListEditor({ list, sortList, handleCheckboxChange, itemMethods, setHeaderTitle, isListEmpty }) {
	let { url } = useRouteMatch();
	const [ inputValue, setInputValue ] = useState('');

	const handleSearchChange = (e) => {
		let input = e.target;
		setInputValue(input.value);
	};

	let { searchResults, searchMatch } = itemMethods.search(inputValue, list);

	// If there is no match, default to the full original list
	if (!searchMatch) {
		searchResults = list;
	}

	useEffect(
		() => {
			setHeaderTitle('Ma liste - Gestion');
		},
		[ setHeaderTitle ]
	);

	return (
		<Page>
			{!isListEmpty() ? (
				<Fragment>
					<SearchBar handleSearchChange={handleSearchChange} inputValue={inputValue} />
					{!searchMatch && inputValue.length >= 3 ? <NoResult inputValue={inputValue} /> : ''}
					<div>
						<ListSection
							type="roomtemp"
							list={sortList(searchResults.roomtemp)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={itemMethods}
						/>
						<ListSection
							type="fridge"
							list={sortList(searchResults.fridge)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={itemMethods}
						/>
						<ListSection
							type="freezer"
							list={sortList(searchResults.freezer)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={itemMethods}
						/>
					</div>
				</Fragment>
			) : (
				<div className="emptyList">
					<p className="emptyList__p">
						Votre liste est vide. <br />Ajoutez-y des produits!
					</p>
					<Link to="/lists/new">
						<button className="emptyList__actionBtn">Ajouter un produit</button>
					</Link>
				</div>
			)}

			<FloatingActionBtn path={`${url}/new`} image={'add'} />
			<Switch>
				<Route path={`${url}/new`}>
					<ItemForm itemMethods={itemMethods} edit={false} />
				</Route>

				<Route path={`${url}/:id`}>
					<ItemForm itemMethods={itemMethods} edit={true} />
				</Route>
			</Switch>
		</Page>
	);
}

export default ListEditor;
